/**
 * Created by evgeny on 18.07.2024
 */

const HomefixIdComponent = function (unit, options, name) {
    UnitComponent.call(this, unit);
    if (cleverapps.environment.isAdministratorScene() || cleverapps.environment.isEditorScene()) {
        return;
    }

    this.furniture = Homefix.currentHomefix.getFurnitureByName(name);
    if (this.furniture) {
        this.furniture = Homefix.currentHomefix.getFurnitureByName(name);
        this.furniture.bindUnit(unit);
    } else {
        cleverapps.throwAsync(`No furniture for unit ${unit.code}`);
    }

    this.update();
    this.onSpendStarAnimation = function () {};
};

HomefixIdComponent.prototype = Object.create(UnitComponent.prototype);
HomefixIdComponent.prototype.constructor = HomefixIdComponent;

HomefixIdComponent.prototype.update = function () {
    const hightlight = this.unit.findComponent(HighLight);
    if (!hightlight) {
        return;
    }
    if (this.furniture.isCurrent()) {
        hightlight.addHighlight();
    } else {
        hightlight.removeHighlight();
    }
};

HomefixIdComponent.prototype.handleClick = function () {
    if (!this.furniture || !this.furniture.isCurrent()) {
        if (Homefix.currentHomefix.location.isCompleted()) {
            cleverapps.focusManager.display({
                focus: "AllDoneWindow",
                action: function (f) {
                    new AllDoneWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        }
        return;
    }

    if (this.furniture.canBeUpgraded()) {
        cleverapps.focusManager.display({
            focus: "moveNext",
            actions: [
                function (f) {
                    this.onSpendStarAnimation(f);
                }.bind(this),
                function (f) {
                    Homefix.currentHomefix.moveNext(this.furniture, f);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }.bind(this)]
        });
    } else {
        cleverapps.focusManager.display({
            focus: "HomefixRulesWindow",
            action:
                function (f) {
                    new GuideWindow({
                        name: "HomefixRulesWindow",
                        bundle: bundles.homefixruleswindow
                    });
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
        });
    }
};